/* CANFOTO V67BS-R17 — contextual verdict ledger, evidence-only, no mutations */
(function(W){'use strict';
const VERSION='CANFOTO-NORA-R17-ROLE-VERDICT-LEDGER-V1';
const NEED=Object.freeze({
 beautyFaceLight:['targetFaceIlluminanceLux','measuredDistanceM','CCT','CRIorTM30','shadowUniformity','setupMainVsFill'],
 deskContentLight:['deskWorkingDistanceM','beamCoverage','modifier','targetIlluminanceLux','physicalFit','fanNoiseIfVideo'],
});
function item(c){
 const contextual=c.role==='beautyFaceLight'||c.role==='deskContentLight';
 const required=(NEED[c.role]||['exactSetupRole','measuredLuxAtDistance','modifier']).slice();
 const pending=!!c.provisional;
 const verdict=contextual?'R2G_MAIN_KEY_FLAG_NOT_DECISIVE_FOR_THIS_ROLE':'ROLE_REQUIREMENT_REVIEW';
 return Object.freeze({key:c.key,lane:c.lane,rank:c.rank,handle:c.handle,sourceHandle:c.sourceHandle,
 role:c.role,area:c.area,effectiveWhitePowerW:c.effectiveWhitePowerW,
 r2gMainKeyEligible:c.mainKeyEligible,verdict,semanticContract:pending?'PROVISIONAL':'LEGACY_MATCHED_NOT_PHOTOMETRY_CERTIFIED',
 evidenceRequired:required,photometry:'UNKNOWN',rankAction:'NONE',scoreAction:'NONE',
 reason:'mainKeyEligible is specific to a MAIN KEY and cannot alone reject contextual face/desk role'});
}
async function audit(){
 const owner=W.CANFOTO_NORA_PANEL_SEMANTIC_DECISION_V67BS_R16;
 if(typeof owner?.audit!=='function')throw Error('HOLD_R16_OWNER_MISSING');
 const src=await owner.audit();
 if(src.status!=='PASS_CONTEXTUAL_HOLD_NO_AUTO_ELIMINATION'||src.sourceParity!==true)throw Error('HOLD_R16_SOURCE_PARITY');
 const top3=(src.top3||[]).map(item),top5=(src.top5||[]).map(item);
 const unresolvedNative=(src.contracts||[]).map(c=>({key:c.key,requirements:c.requiredEvidence,certification:c.certification}));
 const byKey={};for(const row of top5){const k=row.key; (byKey[k]??=[]).push({rank:row.rank,lane:row.lane,handle:row.handle,role:row.role});}
 const consistency={count3:top3.length===8,count5:top5.length===14,uniqueKeys:Object.keys(byKey).length===3,
 contextualNoMainRejection:top5.every(x=>x.verdict==='R2G_MAIN_KEY_FLAG_NOT_DECISIVE_FOR_THIS_ROLE'),
 noAutoApproval:unresolvedNative.length===6&&unresolvedNative.every(c=>c.certification==='PROVISIONAL_NATIVE_EVIDENCE_PENDING'),
 noMissingHandles:top5.every(c=>!!c.handle&&!!c.sourceHandle)};
 return {task:'V67BS_R17_ROLE_VERDICT_LEDGER',version:VERSION,mode:'READ_ONLY_SHADOW',top3,top5,byKey,
 unresolvedNative,checks:consistency,counts:{top3:top3.length,top5:top5.length,contextualRole:top5.filter(c=>c.verdict.startsWith('R2G_MAIN_KEY')).length,
 provisionalCases:top5.filter(c=>c.semanticContract==='PROVISIONAL').length},
 scoreMutation:false,rankMutation:false,fpCurveMutation:false,photometryCertified:false,
 status:Object.values(consistency).every(Boolean)?'PASS_LEDGER_NO_FALSE_REJECTION_WITH_SEMANTIC_HOLD':'HOLD'};
}
W.CANFOTO_NORA_PANEL_ROLE_VERDICT_V67BS_R17=Object.freeze({version:VERSION,audit,scoreMutation:false,rankMutation:false,fpCurveMutation:false});
})(window);
